module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/fefbb4a5dce8299c6f65f7688cf1c14d.png";